module.exports = __webpack_public_path__ + "img/bulle_3_choix_metier.30386ecf.png";